import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  open: false,
  isEditBreakDown: false,
  breakDownInformation: null,
  breakDownTable: {
    pageState: {
      page: 0,
      data: [],
      pageSize: 10,
      totalRecords: 0,
      totalPages: 0,
    },
    loading: false,
    tableLoading: false,
    searchedRecord: false,
    recordNotFound: false,
    buttonLoading: {
      addEdit: false,
      delete: false,
    },
  },
};

export const MangeBreakDownReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.TOGGLE_ADD_OR_EDIT_BREAKDOWN:
      return {
        ...state,
        open: payload,
      };

    case ActionTypes.SET_EDIT_BREAKDOWN:
      return {
        ...state,
        isEditBreakDown: payload,
      };

    case ActionTypes.SET_EDIT_BREAKDOWN_INFORMATION:
      return {
        ...state,
        breakDownInformation: payload,
      };

    case ActionTypes.RESET_BREAKDOWN_VALUES:
      return {
        ...state,
        breakDownInformation: {
          ...state.breakDownInformation,
          breakdownName: "",
          possibleValues: "",
          breakdownType: {
            id: "",
          },
        },
      };

    case ActionTypes.SET_BREAKDOWNTABLE_LIST:
      return {
        ...state,
        breakDownTable: {
          ...state?.breakDownTable,
          pageState: {
            page: payload?.page,
            data: payload?.data,
            pageSize: 10,
            totalRecords: payload?.totalRecords,
            totalPages: payload?.totalPages,
          },
          recordNotFound: !payload?.data?.length > 0,
        },
      };

    case ActionTypes.SET_SEARCHED_BREAKDOWN_STATUS:
      return {
        ...state,
        breakDownTable: {
          ...state?.breakDownTable,
          searchedRecord: payload,
        },
      };

    case ActionTypes.BREAKDOWN_TABLE_LOADING:
      return {
        ...state,
        breakDownTable: {
          ...state?.breakDownTable,
          loading: payload,
        },
      };

    case ActionTypes.BREAKDOWN_TABLE_FULL_PAGE_LOADING:
      return {
        ...state,
        breakDownTable: {
          ...state?.breakDownTable,
          tableLoading: payload,
        },
      };

    case ActionTypes.BREAKDOWN_BUTTON_LOADING:
      return {
        ...state,
        breakDownTable: {
          ...state?.breakDownTable,
          buttonLoading: {
            ...state?.breakDownTable?.buttonLoading,
            [payload?.field]: payload?.value,
          },
        },
      };

    case ActionTypes.UPDATE_BREAKDOWN:
      const updatedData = state?.breakDownTable?.pageState?.data.map((item) => {
        if (item?.id === payload?.id) {
          return payload;
        }
        return item;
      });
      return {
        ...state,
        breakDownTable: {
          ...state?.breakDownTable,
          pageState: {
            ...state?.breakDownTable?.pageState,
            data: updatedData,
          },
        },
      };

    case ActionTypes.ADD_BREAKDOWN:
      return {
        ...state,
        breakDownTable: {
          ...state?.breakDownTable,
          pageState: {
            ...state?.breakDownTable?.pageState,
            data: [payload, ...state?.breakDownTable?.pageState?.data],
            totalRecords: state?.breakDownTable?.pageState?.totalRecords + 1,
          },
        },
      };

    case ActionTypes.DELETE_BREAKDOWN:
      return {
        ...state,
        breakDownTable: {
          ...state?.breakDownTable,
          pageState: {
            ...state?.breakDownTable?.pageState,
            data: state?.breakDownTable?.pageState?.data?.filter(
              (item) => item?.id !== payload?.id
            ),
            totalRecords: state?.breakDownTable?.pageState?.totalRecords - 1,
            totalPages:
              state?.breakDownTable?.pageState?.data?.length === 1
                ? state?.breakDownTable?.pageState?.totalPages - 1
                : state?.breakDownTable?.pageState?.totalPages,
          },
        },
      };

    default:
      return state;
  }
};
